import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';

@Component({
  selector: 'app-delete-corporate',
  templateUrl: './delete-corporate.component.html',
  styleUrls: ['./delete-corporate.component.css']
})
export class DeleteCorporateComponent implements OnInit {
  api_success: string;
  api_error: any;

  constructor(private corporateService: CorporateService, @Inject(MAT_DIALOG_DATA) public data,
   private dialogRef: MatDialogRef<any>) { }
  disableConfirmbtn = false;
  ngOnInit() {
  }

  onDeleteConfirm() {
    this.disableConfirmbtn = true;
    this.corporateService.deleteCorporate(this.data)
    .subscribe(result => {
     this.api_success = 'Corporate deleted successfully';
     setTimeout(() => {
      this.dialogRef.close('reloadlist');
      }, 2000);
    },
    (error) => {
      this.disableConfirmbtn = false;
     this.api_error = error.error;
     }
   );

  }
}
